var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5968 20.4902H3.50891C1.87189 20.4902 0.540161 19.0884 0.540161 17.3652V6.7793C0.540161 5.05612 1.87189 3.6543 3.50891 3.6543H10.5968C12.2338 3.6543 13.5656 5.05612 13.5656 6.7793V17.3652C13.5656 19.0884 12.2338 20.4902 10.5968 20.4902ZM3.50891 5.2168C2.69048 5.2168 2.02454 5.91779 2.02454 6.7793V17.3652C2.02454 18.2267 2.69048 18.9277 3.50891 18.9277H10.5968C11.4152 18.9277 12.0812 18.2267 12.0812 17.3652V6.7793C12.0812 5.91779 11.4152 5.2168 10.5968 5.2168H3.50891ZM16.5343 15.4121V3.61523C16.5343 1.89206 15.2026 0.490234 13.5656 0.490234H5.32727C4.91733 0.490234 4.58508 0.839966 4.58508 1.27148C4.58508 1.703 4.91733 2.05273 5.32727 2.05273H13.5656C14.384 2.05273 15.0499 2.75372 15.0499 3.61523V15.4121C15.0499 15.8436 15.3822 16.1934 15.7921 16.1934C16.2021 16.1934 16.5343 15.8436 16.5343 15.4121Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-icon.de7d442c80c650326b6be98ed6f2b679.svg";